const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Forma-1",
    serifId: "Forma 1",
    transform: "matrix(1,0,0,1,-1281,-32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1293.05,32C1286.46,32 1281,37.362 1281,43.953C1281,50.544 1286.46,56 1293.05,56C1299.64,56 1305,50.544 1305,43.953C1305,37.362 1299.64,32 1293.05,32ZM1297.68,47.099C1298.11,47.533 1298.11,48.24 1297.68,48.674C1297.25,49.105 1296.55,49.112 1296.11,48.674L1293.03,45.563L1289.86,48.675C1289.43,49.109 1288.73,49.109 1288.3,48.675C1287.87,48.24 1287.87,47.534 1288.3,47.099L1291.39,43.988L1288.3,40.876C1287.87,40.441 1287.87,39.735 1288.3,39.3C1288.73,38.866 1289.43,38.866 1289.86,39.3L1293.03,42.413L1296.11,39.3C1296.54,38.867 1297.24,38.865 1297.68,39.3C1298.11,39.735 1298.11,40.441 1297.68,40.876L1294.59,43.988L1297.68,47.099Z",
    style: {
      fill: "rgb(251,80,80)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.200a02ce3880dcec89d4c6b17e9b57b2.svg";
export { ForwardRef as ReactComponent };